import { History } from "lucide-react";
import { fechaCorta } from "@/lib/migracion";

// Aviso sobrio de la migración de cartera en Perfil 360 y en el detalle del cliente.
export function MigracionAvisoCliente({ cliente }) {
  if (!cliente?.migrado && !cliente?.migracion_vinculado) return null;
  const fecha = fechaCorta(cliente.migracion_fecha);
  const lote = cliente.migracion_lote_id || "—";
  return (
    <div className="mb-3 flex items-start gap-2 rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-700"
      data-testid={cliente.migrado ? "cliente-aviso-migrado" : "cliente-aviso-vinculado"}>
      <History className="mt-0.5 h-4 w-4 shrink-0 text-slate-500" />
      {cliente.migrado ? (
        <span>
          Cliente migrado de otro sistema el {fecha} (lote {lote}). Expediente en resguardo físico de la entidad;
          el expediente digital está pendiente.
        </span>
      ) : (
        <span>
          Este cliente ya existía en FELVORA y fue vinculado a la migración del {fecha} (lote {lote}).
          Número anterior: {cliente.numero_cliente_anterior || "—"}.
        </span>
      )}
    </div>
  );
}
